<template>
  <div>
    <list-page-view
      ref="dec"
      title="供货资质定义"
      :needSearch="false"
      :bodyStyle="{ 'min-height': '500px' }"
      searchHint="资质证书类别"
      @toQuery="toQuery"
      @toReset="toReset"
    >
      <a-row :gutter="20">
        <a-col :span="10">
          <a-card title="供货类别 ">
            <a slot="extra" @click="toAdd" href="#">新增</a>
            <uto-table-new
              ref="desc1"
              :columns="columns1"
              :loadParams="loadParams"
              :url="queryUrl"
              :conditions="conditions"
              rowKey="id"
              :customRow="rowClick"
              bordered
              sortField="create_time"
              sortOrder="desc"
            >
              <template slot="actionT" slot-scope="flag, record">
                <a @click="toEdit(record)">修改</a>
                <a-divider type="vertical" />
                <a-popconfirm placement="topRight" title="确认删除?" @confirm="() => toDelete(record)">
                  <a>删除</a>
                </a-popconfirm>
              </template>
            </uto-table-new>
          </a-card>
        </a-col>
        <a-col :span="14">
          <a-card :title="bodytitle">
            <!--  -->
            <a slot="extra" @click="toAdd2">新增</a>
            <uto-table-new ref="desc2" :columns="columns2" :dataSource="dataSource" bordered sortField="" sortOrder="desc">
              <template slot="actionT" slot-scope="flag, record">
                <a @click="toEdit2(record)">修改</a>
                <a-divider type="vertical" />
                <a-popconfirm placement="topRight" title="确认删除?" @confirm="() => toDetailDelete(record)">
                  <a>删除</a>
                </a-popconfirm>
              </template>
              <template slot="needT" slot-scope="flag, record">
                <span v-if="flag">
                  是
                </span>
                <span v-else>否</span>
              </template>
            </uto-table-new>
          </a-card>
        </a-col>
      </a-row>
      <!-- :needColumn="true"  @selectColumnOK="selectColumnOK"   @STSelectedDataKeys="STSelectedDataKeys" :needExport="true"  @toExport="toExport"  @toColumn="toColumn"-->
    </list-page-view>

    <certificate-define-m-1 ref="head" @success="toQuery"> </certificate-define-m-1>
    <certificate-define-m-2 ref="body" @success="getData(ghlbInfo.id)"></certificate-define-m-2>
  </div>
</template>
<script>
import moment from 'moment'
import { scmApi, defRemove, supptypeRemove, querySupplyDefinitionDetail } from '@/api/scmApi'
import CertificateDefineM1 from './module/CertificateDefineM1.vue'
import CertificateDefineM2 from './module/CertificateDefineM2.vue'

export default {
  name: 'CertificateType',
  components: { CertificateDefineM1, CertificateDefineM2 },
  data() {
    return {
      selectedRowKeys: [],
      selectedRows: [],
      dataSource: [],
      userinfo: this.$store.getters.userinfo,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      ddate: null,
      columns1: [
        {
          title: '操作',
          width: 120,
          dataIndex: 'action',
          scopedSlots: { customRender: 'actionT' }
        },
        {
          title: '供货类别',
          dataIndex: 'supply_type',
          width: 130
        },
        {
          title: '备注',
          dataIndex: 'remark',
          width: 200
        }
      ],
      columns2: [
        {
          title: '操作',
          width: 120,
          dataIndex: 'action',
          scopedSlots: { customRender: 'actionT' }
        },
        {
          title: '资质证书的种类',
          dataIndex: 'certificate_name',
          width: 130
        },
        {
          title: '是否必须',
          dataIndex: 'need',
          scopedSlots: { customRender: 'needT' },
          width: 100
        },
        {
          title: '备注',
          dataIndex: 'remark',
          width: 180
        }
      ],
      loadParams: {},
      queryUrl: scmApi.querySupplyDefinitionType,
      queryUrl2: '',
      cdateR: [],
      headId: '',
      ghlbInfo: null,
      bodytitle: '认证内容定义',
      conditions: {
        cinvcode: 'like_anywhere',
        cinvname: 'like_anywhere'
      }
    }
  },
  created() {},
  methods: {
    rowClick(record, index) {
      const that = this
      return {
        style: {
          cursor: 'pointer'
          // background: '#ccc'
        },
        on: {
          click: () => {
            that.ghlbInfo = record
            that.bodytitle = record.supply_type + '-认证内容定义'
            that.getData(record.id)
          }
        }
      }
    },
    getData(id) {
      const that = this
      querySupplyDefinitionDetail({ definition_type_id: id }).then(res => {
        if (res.code == 0) {
          that.$nextTick(() => {
            that.dataSource = res.data
          })
        } else {
          that.dataSource = []
          that.$message.error(res.msg ? res.msg : '加载失败')
        }
      })
    },
    toAdd() {
      this.$refs.head.toAddOrUpdate()
    },
    toAdd2() {
      if (this.ghlbInfo) {
        this.$refs.body.toAddOrUpdate(this.ghlbInfo)
      } else {
        this.$message.warning('请选择供货类别，再进行新增！')
      }
    },
    toEdit(record) {
      this.$refs.head.toAddOrUpdate(record)
    },
    toEdit2(record) {
      this.$refs.body.toAddOrUpdate(this.ghlbInfo, record)
    },
    toDelete(record) {
      const that = this
      zsRemove({ id: record.id })
        .then(res => {
          if (String(res.code) === '0') {
            that.$message.success('删除成功！')
            const params = {}
            params.ccode = that.ccode
            that.toPublishList(params)
          } else {
            that.$message.error(res ? res.msg : '发布失败，请联系管理员')
          }
        })
        .catch(function() {
          that.$message.error('数据加载失败，请稍后再试！')
        })
    },
    toDetailDelete(record) {
      const that = this
      defRemove({ id: record.id })
        .then(res => {
          if (res.code == 0) {
            that.$message.success('删除成功！')
            that.getData(this.ghlbInfo.id)
          } else {
            that.$message.error(res ? res.msg : '删除失败，请联系管理员')
          }
        })
        .catch(function() {
          that.$message.error('数据加载失败，请稍后再试！')
        })
    },

    toQuery() {
      this.queryUrl = scmApi.querySupplyDefinitionType + '?t=' + parseInt(Math.random() * 1000)
    },

    toReset() {
      this.loadParams = {}
      this.toQuery()
    }

    // STSelectedDataKeys(d) {
    //   if (d && d.length > 0) {
    //     const eConf = {
    //       eFile: '供应商询价'
    //     }
    //     eConf['type'] = '3'
    //     eConf['ids'] = d.join(',')
    //     eConf['col'] = 'ccode'
    //     this.$refs.desc.toExport(eConf)
    //   }
    // },
    // //时间
    // handleChange(e) {
    //   const _that = this
    //   if (e.length > 0) {
    //     _that.loadParams['cdate$1'] = e[0] ? e[0].format('YYYY-MM-DD') : ''
    //     _that.loadParams['cdate$2'] = e[1] ? e[1].format('YYYY-MM-DD') : ''
    //   } else {
    //     _that.loadParams['cdate$1'] = ''
    //     _that.loadParams['cdate$2'] = ''
    //   }
    // },
    // toExport(e) {
    //   const eConf = {
    //     eFile: '供应商询价'
    //   }
    //   if (e.key === 'all') {
    //     eConf['type'] = '1'
    //     this.$refs.desc1.toExport(eConf)
    //   } else if (e.key === 'page') {
    //     eConf['type'] = '2'
    //     this.$refs.desc1.toExport(eConf)
    //   } else {
    //     const zmColmuns = [
    //       {
    //         title: '单据号',
    //         dataIndex: 'ccode',
    //         width: 150
    //       },
    //       {
    //         title: '制单人',
    //         dataIndex: 'cmaker',
    //         width: 120
    //       },
    //       {
    //         title: '制单日期',
    //         dataIndex: 'cdate',
    //         width: 150
    //       }
    //     ]
    //     const zmDATA = this.$refs.desc1.getSD()
    //     this.$refs.dec.toSelectData(zmColmuns, zmDATA, 'ccode')
    //   }
    // }
  }
}
</script>
